(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-wbn-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Handle form submission with fetch
  const productForms = document.querySelectorAll('.product-form-with-addons');
  
  productForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const addToCartButton = form.querySelector('[type="submit"]');
      const originalButtonText = addToCartButton.textContent;
      const mainProductId = form.dataset.productId;
      const mainQuantity = parseInt(formData.get('quantity') || 1);
      const mainOptions = [];
      
      // Get selected variant options
      const optionSelects = form.querySelectorAll('select[name="options[]"]');
      optionSelects.forEach(select => {
        if(select.value) mainOptions.push(select.value);
      });
      
      // Disable button and show loading state
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Adding...';
      
      try {
        // Create array of items to add (main product + addons)
        const itemsToAdd = [{
          id: mainProductId,
          quantity: mainQuantity,
          properties: {}
        }];
        
        // Add all checked add-ons
        const checkedAddons = form.querySelectorAll('.addon-checkbox:checked');
        checkedAddons.forEach(addon => {
          itemsToAdd.push({
            id: addon.dataset.productId,
            quantity: 1,
            properties: {}
          });
        });
        
        // Add all items in one request
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: itemsToAdd
          })
        });
        
        const data = await response.json();
        
        if (response.status === 422) {
          throw new Error(data.description || 'Failed to add to cart');
        }
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        // Show success message
        showCartNotification();
        
        // Update cart count in header
        updateCartCount();
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        showErrorNotification(error.message || 'Error adding items to cart, please try again');
      } finally {
        // Reset button state
        addToCartButton.disabled = false;
        addToCartButton.textContent = originalButtonText;
      }
    });
  });
  
  // Show success notification
  function showCartNotification() {
    const existing = document.querySelector('.add-to-cart-notification');
    if (existing) existing.remove();
    
    const notification = document.createElement('div');
    notification.className = 'add-to-cart-notification';
    notification.innerHTML = `
      <div class="notification-content">
        <p>Items added to your cart!</p>
        <a href="/cart" class="button">View Cart</a>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('fade-out');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  // Show error notification
  function showErrorNotification(message) {
    const existing = document.querySelector('.add-to-cart-notification');
    if (existing) existing.remove();
    
    const notification = document.createElement('div');
    notification.className = 'add-to-cart-notification error';
    notification.innerHTML = `
      <div class="notification-content">
        <p>${message}</p>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('fade-out');
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  }
  
  // Update cart count in header
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('.cart-count, #cart-count, .js-cart-count');
      
      if (cartCountElements) {
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
          el.classList.remove('hidden-count');
        });
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
